/*
UPDATE 20 Dec, 2022 [ref email: "Street Sweeper Website Update"]
- The street sweeper will now sweep every 14 days for all streets in the CB City.
*/
export default function getNextSweepDate(lastSweepEpochTime: string): string {
  const lastSweepDate = new Date(parseInt(lastSweepEpochTime));
  lastSweepDate.setDate(lastSweepDate.getDate() + 14);
  return lastSweepDate.toLocaleDateString("en-AU", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
